/**
 * @eneco/chatbot-types
 *
 * Public contract types and utilities for the chatbot's Window API.
 * This package is the shared interface between @eneco/chatbot (the standalone
 * IIFE bundle) and host applications (e.g. chatv2) that interact with it
 * via `window.sparkyChat`.
 *
 * By depending on this package instead of @eneco/chatbot directly, host
 * applications avoid a compile-time dependency on the chatbot implementation,
 * preventing unnecessary NX build cascades.
 */

// Configuration types (public Window API contract)
export type {
  AuthTokens,
  Channel,
  ChatbotCallbacks,
  ChatbotInitOptions,
  ChatbotState,
  ConnectionStatus,
  ConversationData,
  LayoutMode,
  LoginRequiredData,
  Namespace,
  Visibility,
  VisibilityState,
} from './config';

// Error types
export type { ChatbotErrorPayload, ChatbotErrorType } from './errors';

// Tracking types
export type {
  ChatbotTrackingAction,
  ChatbotTrackingEvent,
  ChatbotTrackingParams,
  TrackingPayload,
} from './tracking';

// Window API interface
export type { WindowSparkyChatAPI } from './window';

// Session utilities
export { getPendingOAuth, savePendingOAuth, clearPendingOAuth } from './session-utils';
export type { PendingOAuthData } from './session-utils';
